import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useLang } from "@/context/LangContext";
import { MultiLangField } from "@/components/admin/Fields";

export const PackagesManager = ({ packages = [], onChange }) => {
  const { t, tr } = useLang();
  const update = (i, patch) => onChange(packages.map((p, idx) => (idx === i ? { ...p, ...patch } : p)));
  const add = () => onChange([...packages, { id: "", price: "", reward: "", name: { en: "New package", am: "", om: "" }, features: { en: "", am: "", om: "" } }]);

  return (
    <div className="space-y-5">
      {packages.map((p, i) => (
        <div key={p.id || `new-${i}`} className="space-y-5 rounded-2xl border border-border p-5" data-testid={`admin-package-editor-${i}`}>
          <div className="flex items-center justify-between">
            <span className="text-lg font-bold">{tr(p.name) || `#${i + 1}`}</span>
            <button type="button" onClick={() => onChange(packages.filter((_, idx) => idx !== i))} data-testid={`admin-package-remove-${i}`} className="inline-flex items-center gap-1 rounded-full border border-rose-300 px-3 py-1.5 text-xs font-semibold text-rose-700 hover:bg-rose-50 dark:border-rose-800 dark:text-rose-400 dark:hover:bg-rose-950">
              <Trash2 className="h-3.5 w-3.5" />{t("remove")}
            </button>
          </div>
          <div className="grid max-w-xl gap-4 sm:grid-cols-2">
            <div className="space-y-2">
              <Label className="text-sm font-bold">{t("reg_payment")}</Label>
              <Input value={p.price} onChange={(e) => update(i, { price: e.target.value })} data-testid={`admin-package-price-${i}`} />
            </div>
            <div className="space-y-2">
              <Label className="text-sm font-bold">{t("reward")}</Label>
              <Input value={p.reward || ""} onChange={(e) => update(i, { reward: e.target.value })} data-testid={`admin-package-reward-${i}`} />
            </div>
          </div>
          <MultiLangField label={t("package_name")} value={p.name} onChange={(v) => update(i, { name: v })} testPrefix={`admin-package-name-${i}`} />
          <MultiLangField label={t("package_features_hint")} value={p.features} onChange={(v) => update(i, { features: v })} multiline testPrefix={`admin-package-features-${i}`} />
        </div>
      ))}
      <button type="button" onClick={add} data-testid="admin-package-add-button" className="inline-flex items-center gap-2 rounded-full border border-dashed border-primary px-5 py-2.5 text-sm font-bold text-primary hover:bg-primary/5">
        <Plus className="h-4 w-4" />{t("add_package")}
      </button>
    </div>
  );
};
